import { createContext, useContext, ComponentType } from 'react'
import i18n from '@signavio/i18n'

import { DangerHint } from '@signavio/ui'

import { useApi } from '../../api'
import apiTypes from '../../apiTypes'
import { ServiceType } from '../../../types'

const ServicesContext = createContext<ServiceType[]>([])

export type ServicesProviderProps = React.FC<React.PropsWithChildren<unknown>>

export const ServicesProvider: ServicesProviderProps = ({ children }) => {
  const [services] = useApi(apiTypes.SERVICES)

  if (services.rejected) {
    return (
      <DangerHint title={i18n('Loading services failed')}>
        {services.reason}
      </DangerHint>
    )
  }

  if (!services.value) {
    return null
  }

  return (
    <ServicesContext.Provider value={services.value}>
      {children}
    </ServicesContext.Provider>
  )
}

export type TestServicesProviderProps = React.FC<
  React.PropsWithChildren<{ services: ServiceType[] }>
>

export const TestServicesProvider: TestServicesProviderProps = ({
  children,
  services,
}) => {
  return (
    <ServicesContext.Provider value={services}>
      {children}
    </ServicesContext.Provider>
  )
}

export function useServices(): ServiceType[] {
  return useContext(ServicesContext)
}

export function withServices<T>(
  WrappedComponent: ComponentType<React.PropsWithChildren<T>>
): ComponentType<React.PropsWithChildren<T & { services: ServiceType[] }>> {
  return function WithServices(props) {
    return <WrappedComponent {...props} services={useServices()} />
  }
}
